import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const postBulkQrCode = (id, storeId, orderId,data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/bulk-qrcode',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};
